// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import { AccordionWrapper } from './styled';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { fg } from '@atlaskit/platform-feature-flags';

export const TRANSITION_DURATION_MS = 100;
export const ANIMATION_DURATION = 200;

export interface AccordionItemProps {
	children: React.ReactNode;
	expanded: boolean;
	id: string;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
	id,
	expanded,
	children,
}: AccordionItemProps) => {
	if (fg('jira_onboarding_a11y_fixes_for_quickstart')) {
		return (
			<Box
				as="li"
				xcss={accordionWrapperStyles}
				data-test-expanded={expanded}
				testId={`checklist-accordion-item-${id}`}
			>
				{children}
			</Box>
		);
	}
	return (
		<AccordionWrapper data-testid={`checklist-accordion-item-${id}`} data-test-expanded={expanded}>
			{children}
		</AccordionWrapper>
	);
};

const accordionWrapperStyles = xcss({
	backgroundColor: 'elevation.surface.raised',
	boxShadow: 'elevation.shadow.raised',
	marginTop: 'space.0',
	listStyleType: 'none',
});

export default AccordionItem;
